export default __webpack_public_path__ + "static/media/filter.931599d8.svg";